<template>
  <div class="itens">
    <div class="container d-none d-lg-block">
      <ul class="row align-items-center justify-content-center">
        <li v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'apresentacao'" class="text-center" @click="scrollTop()">
          <router-link :to="{ name: 'InternaApresentacao', params: { slug:slug }}">
            <div class="imagem">
              <img src="../../assets/img/icon-presentation.png" alt="Apresentação">
            </div>
            Apresentação
          </router-link>
        </li>
        <li v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'plantas'" class="text-center" @click="scrollTop()">
          <router-link :to="{ name: 'InternaPlantas', params: { slug:slug }}">
            <div class="imagem">
              <img src="../../assets/img/icon-plant.png" alt="Plantas">
            </div>
            Plantas
          </router-link>
        </li>
        <li v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'galeria'" class="text-center" @click="scrollTop()">
          <router-link :to="{ name: 'InternaGaleria', params: { slug:slug }}">
            <div class="imagem">
              <img src="../../assets/img/icon-photo.png" alt="Galeria">
            </div>
            Galeria 3D
          </router-link>
        </li>
        <li v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'tour'" class="text-center" @click="scrollTop()">
          <router-link :to="{ name: 'InternaTour', params: { slug:slug }}">
            <div class="imagem">
              <img src="../../assets/img/icon-360.png" alt="Tour 360°">
            </div>
            Tour 360°
          </router-link>
        </li>
        <li v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'estagio'" class="text-center" @click="scrollTop()">
          <router-link :to="{ name: 'InternaEstagio', params: { slug:slug }}">
            <div class="imagem">
              <img src="../../assets/img/icon-stage.png" alt="Estágio da Obra">
            </div>
            Estágio da Obra
          </router-link>
        </li>
        <li v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'localizacao'" class="text-center" @click="scrollTop()">
          <router-link :to="{ name: 'InternaLocalizacao', params: { slug:slug }}">
            <div class="imagem">
              <img src="../../assets/img/icon-location.png" alt="Localização">
            </div>
            Localização
          </router-link>
        </li>
        <li v-if="status == 1" class="text-center" @click="selecionaContato()">
          <router-link :to="'/contato/'+slug">
            <div class="imagem">
              <img src="../../assets/img/icon-whatsapp.png" alt="Entre em contato">
            </div>
            Entre em contato
          </router-link>
        </li>
      </ul>
    </div>
    <div class="container d-blog d-lg-none">
      <ul class="carousel_items">
        <carousel
        :per-page="1"
        :paginationPadding="5"
        :paginationSize="15"
        :paginationActiveColor="'#13182c'"
        :perPageCustom="[[480, 1], [768, 3], [1024, 7]]"
        :loop="true"
        :autoplay="false"
        :paginationEnabled="false"
        :navigationEnabled="true"
        navigationNextLabel='<i class="fa fa-chevron-right left_itens"></i>'
        navigationPrevLabel='<i class="fa fa-chevron-left right_itens" aria-hidden="true"></i>'
        >
        <slide v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'apresentacao'">
          <li class="text-center" @click="scrollTop()">
            <router-link :to="{ name: 'InternaApresentacao', params: { slug:slug }}">
              <div class="imagem">
                <img src="../../assets/img/icon-presentation.png" alt="Apresentação">
              </div>
              Apresentação
            </router-link>
          </li>
        </slide>
        <slide v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'plantas'">
          <li class="text-center" @click="scrollTop()">
            <router-link :to="{ name: 'InternaPlantas', params: { slug:slug }}">
              <div class="imagem">
                <img src="../../assets/img/icon-plant.png" alt="Plantas">
              </div>
              Plantas
            </router-link>
          </li>
        </slide>
        <slide v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'galeria'">
          <li class="text-center" @click="scrollTop()">
            <router-link :to="{ name: 'InternaGaleria', params: { slug:slug }}">
              <div class="imagem">
                <img src="../../assets/img/icon-photo.png" alt="Galeria">
              </div>
              Galeria 3D
            </router-link>
          </li>
        </slide>
        <slide v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'tour'">
          <li class="text-center" @click="scrollTop()">
            <router-link :to="{ name: 'InternaTour', params: { slug:slug }}">
              <div class="imagem">
                <img src="../../assets/img/icon-360.png" alt="Tour 360°">
              </div>
              Tour 360°
            </router-link>
          </li>
        </slide>
        <slide v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'estagio'">
          <li class="text-center" @click="scrollTop()">
            <router-link :to="{ name: 'InternaEstagio', params: { slug:slug }}">
              <div class="imagem">
                <img src="../../assets/img/icon-stage.png" alt="Estágio da Obra">
              </div>
              Estágio da Obra
            </router-link>
          </li>
        </slide>
        <slide v-for="(menu,index) in menus" :key="index" v-if="menu.slug == 'localizacao'">
          <li class="text-center" @click="scrollTop()">
            <router-link :to="{ name: 'InternaLocalizacao', params: { slug:slug }}">
              <div class="imagem">
                <img src="../../assets/img/icon-location.png" alt="Localização">
              </div>
              Localização
            </router-link>
          </li>
        </slide>
        <slide v-if="status == 1">
          <li class="text-center" @click="selecionaContato()">
            <router-link to="/contato">
              <div class="imagem">
                <img src="../../assets/img/icon-whatsapp.png" alt="Entre em contato">
              </div>
              Entre em contato
            </router-link>
          </li>
        </slide>
      </carousel>
    </ul>
  </div>
</div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  props: ['slug', 'menus', 'title', 'status'],
  components: {
    Carousel,
    Slide
  },
  methods: {
    selecionaContato () {
      localStorage.setItem('empreendimento', this.title)
    },
    scrollTop () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.itens {
  background: $bgIntern;
  padding: 50px 0;
  li {
    margin: 0 25px;
    position: relative;
    a {
      color: $silver;
      font-size: 16px;
      font-weight: 300;
      text-transform: uppercase;
      transition: all 0.2s;
      .imagem {
        padding-bottom: 20px;
      }
      &:hover {
        color: $green;
        transition: all 0.2s;
      }
    }
  }
  .router-link-active {
    font-weight: 900;
    transition: all 0.3s;
    &:after {
      background: $green;
      bottom: -50px;
      content: '';
      height: 10px;
      left: 0;
      position: absolute;
      transition: all 0.3s;
      width: 100%;
      z-index: 10;
    }
  }
  @media (max-width: 1200px) {
    li {
      margin: 0 10px 10px 10px;
      a {
        font-size: 15px;
      }
    }
    .router-link-active {
      &:after {
        bottom: -65px;
      }
    }
  }
  @media (max-width: 991px) {
    padding: 40px 0 30px 0;
    li {
      margin-bottom: 25px;
    }
    .router-link-active {
      &:after {
        bottom: -20px;
      }
    }
  }
  @media (max-width: 767px) {
    li {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
    }
    .router-link-active {
      &:after {
        width: 150px;
        left: calc(50% - 75px);
        bottom: -10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaItens.vue